import { render, staticRenderFns } from "./company-documents-menu.vue?vue&type=template&id=035f8738&"
import script from "./company-documents-menu.vue?vue&type=script&lang=js&"
export * from "./company-documents-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports